module.exports = __webpack_public_path__ + "img/financial-graph.0e733391.png";